export default __webpack_public_path__ + "f997bb137934e99ab86c18e111548524.png";